var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSafePhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 48.047 60"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M34.571 54.727a3.516 3.516 0 01-3.513 3.515H5.274a3.516 3.516 0 01-3.516-3.515V5.274a3.516 3.516 0 013.516-3.516h25.784a3.516 3.516 0 013.516 3.516z",
  fill: "#8dcbfd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M31.055 1.758H18.164v56.484h12.891a3.516 3.516 0 003.516-3.516V5.274a3.516 3.516 0 00-3.516-3.516z",
  fill: "#6cbbed"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.68 49.453h-7.031a1.758 1.758 0 100 3.515h7.031a1.758 1.758 0 100-3.515z",
  fill: "#fff5f5"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M21.68 52.968a1.758 1.758 0 100-3.515h-3.516v3.515z",
  fill: "#dfdef5"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M31.055 0H5.273A5.279 5.279 0 000 5.273v49.454A5.279 5.279 0 005.273 60h25.782a5.279 5.279 0 005.273-5.273V5.273A5.279 5.279 0 0031.055 0zm1.758 54.727a1.758 1.758 0 01-1.758 1.758H5.273a1.758 1.758 0 01-1.758-1.758V5.273a1.758 1.758 0 011.758-1.758h4.592l1.357 4.071a1.758 1.758 0 001.668 1.2h10.548a1.758 1.758 0 001.668-1.2l1.357-4.071h4.592a1.758 1.758 0 011.758 1.758z",
  fill: "#e7f0ef"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M31.055 0H18.164v8.789h5.274a1.757 1.757 0 001.667-1.2l1.359-4.073h4.592a1.758 1.758 0 011.758 1.758v49.453a1.758 1.758 0 01-1.758 1.758H18.164V60h12.891a5.279 5.279 0 005.273-5.273V5.273A5.279 5.279 0 0031.055 0z",
  fill: "#d8e6e8"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M47.532 19.38l-4.687-4.688a1.758 1.758 0 00-1.243-.515H27.539a1.758 1.758 0 00-1.243.515l-4.687 4.688a1.757 1.757 0 00-.515 1.243v6.129a20.4 20.4 0 0012.824 18.941 1.758 1.758 0 001.306 0 20.4 20.4 0 0012.824-18.941v-6.129a1.757 1.757 0 00-.516-1.243z",
  fill: "#ffe478"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M47.532 19.38l-4.687-4.688a1.759 1.759 0 00-1.243-.515H34.57v31.641a1.757 1.757 0 00.653-.126 20.4 20.4 0 0012.823-18.941v-6.129a1.757 1.757 0 00-.514-1.242z",
  fill: "#ffca0f"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M24.609 21.353v5.4a16.8 16.8 0 009.961 15.4 16.8 16.8 0 009.961-15.4v-5.4l-3.658-3.658H28.267z",
  fill: "#ffca0f"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M40.87 17.695h-6.3v24.458a16.8 16.8 0 009.961-15.4v-5.4z",
  fill: "#ff9803"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M38.299 24.756l-5.386 5.386-2.072-2.072a1.758 1.758 0 00-2.486 2.486l3.315 3.314a1.757 1.757 0 002.486 0l6.629-6.629a1.758 1.758 0 10-2.486-2.486z",
  fill: "#fff5f5"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M40.785 24.756a1.758 1.758 0 00-2.486 0l-3.729 3.728v4.972l6.215-6.215a1.758 1.758 0 000-2.485z",
  fill: "#dfdef5"
})));
export default SvgSafePhone;